import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.f3r_1 = new (MarkdownContent())('aboutMd', 'connectSuccessMd', 'contributionStartMd', 'boostMd', 'recentInfoMd', 'installSuccessMd');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var MarkdownContentClass;
function MarkdownContent() {
  if (MarkdownContentClass === VOID) {
    class $ {
      constructor(aboutMd, connectSuccessMd, contributionStartMd, boostMd, recentInfoMd, installSuccessMd) {
        Companion_getInstance();
        this.g3r_1 = aboutMd;
        this.h3r_1 = connectSuccessMd;
        this.i3r_1 = contributionStartMd;
        this.j3r_1 = boostMd;
        this.k3r_1 = recentInfoMd;
        this.l3r_1 = installSuccessMd;
      }
      toString() {
        return 'MarkdownContent(aboutMd=' + this.g3r_1 + ', connectSuccessMd=' + this.h3r_1 + ', contributionStartMd=' + this.i3r_1 + ', boostMd=' + this.j3r_1 + ', recentInfoMd=' + this.k3r_1 + ', installSuccessMd=' + this.l3r_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.g3r_1);
        result = imul(result, 31) + getStringHashCode(this.h3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k3r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l3r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MarkdownContent()))
          return false;
        if (!(this.g3r_1 === other.g3r_1))
          return false;
        if (!(this.h3r_1 === other.h3r_1))
          return false;
        if (!(this.i3r_1 === other.i3r_1))
          return false;
        if (!(this.j3r_1 === other.j3r_1))
          return false;
        if (!(this.k3r_1 === other.k3r_1))
          return false;
        if (!(this.l3r_1 === other.l3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MarkdownContent');
    MarkdownContentClass = $;
  }
  return MarkdownContentClass;
}
//region block: exports
export {
  MarkdownContent as MarkdownContent25fmztzs0fh3a,
  Companion_getInstance as Companion_getInstance3kqyk8vnxc5xb,
};
//endregion

//# sourceMappingURL=MarkdownContent.mjs.map
